import React from "react";
import {
  TabPane,
  Grid,
  Message,
  Icon,
  Divider,
  Button
} from "semantic-ui-react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { userLoggedOut } from "../../actions/auth";

/**
 * SystemPane: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Settings pane containing all system controls, such as
 * version information and user actions.
 *
 * @param {*} props
 */
const SystemPane = props => (
  <TabPane>
    <h3>
      <FormattedMessage
        id="settings.system.title"
        description="Category title for System settings pane"
      />
    </h3>
    <Divider />
    <Grid>
      <Grid.Row>
        <Grid.Column width={3}>
          <b>
            <FormattedMessage
              id="settings.system.version.title"
              description="Title for settings version section"
            />
          </b>
        </Grid.Column>
        <Grid.Column width={8}>
          <p>
            <FormattedMessage id="application.title" />
            <br />
            <FormattedMessage id="application.version" />
            <br />
            <FormattedMessage id="application.stage" />
          </p>
          <Message compact warning>
            <Icon name="asterisk" />
            <FormattedMessage
              id="settings.system.version.betaWarning"
              description="Warning that the user is currently using a prerelease version"
            />
          </Message>
        </Grid.Column>
        <Grid.Column width={4}>
          <p>
            <FormattedMessage
              id="settings.system.version.description"
              description="Description for settings version section"
            />
          </p>
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Divider />
    <Grid>
      <Grid.Row>
        <Grid.Column width={3}>
          <b>
            <FormattedMessage
              id="settings.system.logout.title"
              description="Title for settings logout section"
            />
          </b>
        </Grid.Column>
        <Grid.Column width={8}>
          <Button onClick={props.userLoggedOut}>
            <FormattedMessage
              id="settings.system.logout.action"
              description="Action button text for logging out the current user"
            />
          </Button>
        </Grid.Column>
        <Grid.Column width={4}>
          <p>
            <FormattedMessage
              id="settings.system.logout.description"
              description="Description for settings logout section"
            />
          </p>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </TabPane>
);

SystemPane.propTypes = {
  /**
   * userLoggedOut: () => ()
   * Redux-Action that is dispatched when the user initiates a logout
   */
  userLoggedOut: PropTypes.func.isRequired
};

export default connect(
  null,
  { userLoggedOut }
)(SystemPane);



// WEBPACK FOOTER //
// ./src/modules/settings/SystemPane.js